package kz.dentalcrm.app.data.network.response_model.permissions

import kotlinx.serialization.Serializable

@Serializable
data class Permission(
    val id: Int? = null,
    val name: String? = null,
    val alias: String? = null,
    val created_at: String? = null,
    val updated_at: String? = null
)
